let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("lSzlP")]).then(() => parcelRequire('guaI6'));